<template>
    <div>
       	<label class="lable-full-width">Address Proof*</label>
        <input type="file"    @change="getFile" ref="addrs"  hidden data-from='address'/>
        <label class="choose-btn"  @click="$refs.addrs.click()">Choose file</label>
        <span class="teptext">(Aadhar card, Passport, Voter Id card, Driving License)</span>
        <span id="file-chosen">{{f_data.address_url}}</span>
    </div>
</template>
<script>
import file from '../services/fileupload'
import ls from '../services/ls'
export default {
    name:'address_upload',
    props:['propdata','from_key'],
    watch:{
        propdata:function (data){
            this.f_data = data
        },
        from_key:function (data){
            this.dir_key = data
        }
    },
    data() {
        return{
            f_data:{},
            dir_key:''
        }
    },
    methods: {
           getFile(){
            let formData = new FormData();
            for (var i = 0; i < this.$refs.addrs.files.length; i++) {
                let file = this.$refs.addrs.files[i];
                formData.append('files[' + i + ']', file);
            }
            formData.append('subscription_id', this.propdata.subscribtion_id)
            formData.append('slug', this.propdata.type)
            formData.append('folder_id', this.propdata.folder_id)
            formData.append('session_user', ls.get('_u_unique'));
            formData.append('label', 'Address proof');
            file.uploadProofs(formData)
            .then(response =>{
                 this.$emit("UpdateFilePath", {
                    	src: 'address_proff',
                    	url: response.data.file_url,
                    	action:this.from_key
                });
            })
        }
    }
}
</script>